import React from 'react'
import Footer from './Footer';

const tarifs = (props) => {

    return (
        <div>


            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>


            <div className="resume">
                <div className="resume__background_tarifs"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="resume__heading">
                                <div className="text-light">
                                    <span className="top-title pre-line">Tarifs</span>
                                    <p></p>
                                    <p>* Règlement en espèces, carte bleue ou chèque bancaire.</p>
                                    <p>Certaines mutuelles remboursent la Réflexologie. (Liste non exhaustive : AXA, Klesia, mutuelle, AGF Allianz, MAF, CCMO Mutuelle, AMAVIE, Myriade, Assurema, ALPTIS, APRIL...) Prenez contact avec votre organisme et demandez une facture à l'issue de votre séance.</p>
                                </div>
                                <div className="btn-group nav mt-5">


                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="tab-content">
                                <div className="resume__education tab-pane active" id="education">
                                    <div className="resume__education_item">
                                        <span className="titre-line">RÉFLEXOLOGIE PLANTAIRE :</span>
                                        <p></p>
                                        <span className="pre-line">Séance Adulte</span>
                                        <h5 id="master-in-arts">1 heure - 60 Euros (Cabinet Villeneuve La Garenne)</h5>
                                        <p></p>
                                    </div>
                                    <div className="resume__education_item">
                                        <span className="titre-line">RÉFLEXOLOGIE PLANTAIRE :</span>
                                        <p></p>
                                        <span className="pre-line">Séance Adulte</span>
                                        <h5 id="master-in-arts">Combinée au Chi Nei Tsang : 1h15 - 75 euros</h5>
                                        <p></p>
                                    </div>
                                    <div className="resume__education_item">
                                        <span className="titre-line">RÉFLEXOLOGIE PLANTAIRE :</span>
                                        <p></p>
                                        <span className="pre-line">Séance Enfant jusqu à 12 ans</span>
                                        <h5 id="master-in-arts">45 minutes - 40 euros</h5>
                                        <p></p>
                                    </div>
                                    <div className="resume__education_item">
                                        <span className="titre-line">RÉFLEXOLOGIE PALMAIRE ET MASSAGE DES MAINS:</span>
                                        <p></p>
                                        <span className="pre-line">Séance Adulte</span>
                                        <h5 id="master-in-arts">45 minutes - 45 Euros</h5>
                                        <p></p>
                                    </div>
                                    <div className="resume__education_item">
                                        <span className="titre-line">MASSAGE CRANIEN-NUQUE-EPAULES:</span>
                                        <p></p>
                                        <span className="pre-line">Séance Adulte</span>
                                        <h5 id="master-in-arts">1 heure - 60 Euros</h5>
                                        <p></p>
                                    </div>
                                    <div className="resume__education_item">
                                        <span className="titre-line">CHI NEI TSANG</span>
                                        <p></p>
                                        <span className="pre-line">Séance Adulte</span>
                                        <h5 id="master-in-arts">1h15 - 80 Euros</h5>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>

    );
}

export default tarifs